export default "__VITE_ASSET__CdslKPxG__"